import React, { useState } from 'react';
import { DisabledTag, getTranslatedText, toast } from '@nile/components';
import { Badge, Button, Modal } from '@superops/ui-design-system';
import { Tooltip } from 'react-clone-tippy';
import { SVGIcon } from '@superops/super-icons';
import {
  PATCH_INSTALL_STATUS,
  PATCH_APPROVAL_STATUS
} from '@nile/rmm/src/modules/asset-management/constants/asset-details';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RMMClient } from '@nile/graphql';
import { RUN_LIVE_ACTION } from '@nile/rmm/src/modules/asset-management/Graphql/asset';

const getBadgeStatus = (status) => {
  switch (status) {
    case 'NewOrMissing':
      return 'info';
    case 'Failed':
      return 'critical';
    case 'Installed':
      return 'success';
    case 'RebootRequired':
      return 'warning';
    default:
      return;
  }
};

const getInstallationStatus = (installationStatus) => {
  if (installationStatus === 'NewOrMissing') {
    return 'New Or Missing';
  }

  if (installationStatus === 'RebootRequired') {
    return 'Reboot Required';
  }

  return installationStatus;
};

function PatchStatusCell(props) {
  const { cell, intl } = props;

  const [rebootConfirmation, setRebootConfirmation] = useState(false);
  const [rebootInProgress, setRebootInProgress] = useState(false);

  const toggleRebootConfirmation = () => {
    setRebootConfirmation(!rebootConfirmation);
  };

  const {
    installationStatus,
    failedMessage,
    approvalStatus,
    rollBack,
    workStation
  } = cell?.row?.original || {};

  const patchApprovedOrRejcted =
    approvalStatus === PATCH_APPROVAL_STATUS.PENDING ||
    approvalStatus === PATCH_APPROVAL_STATUS.REJECTED;
  const patchIsInstalled =
    installationStatus === PATCH_INSTALL_STATUS.INSTALLED;

  const rebootRequired = installationStatus === 'RebootRequired';

  const rebootAsset = () => {
    setRebootInProgress(true);
    RMMClient.mutate({
      mutation: RUN_LIVE_ACTION,
      variables: {
        actionType: 'REBOOT',
        assetId: workStation?.assetId,
        input: {
          windowsId: workStation?.assetId
        }
      }
    })
      .then((res) => {
        if (res) {
          setRebootInProgress(false);
          toggleRebootConfirmation();
          toast('success', 'app.toast.asset.detail.reboot.success');
          // Refresh the current list
          cell?.column?.actions?.onClick();
        }
      })
      .catch(() => {
        toast('error', 'app.toast.asset.detail.reboot.fail');
      });
  };

  return (
    <>
      {installationStatus ? (
        <div className="fx actr">
          <Badge
            status={getBadgeStatus(installationStatus)}
            size="large"
            uppercase
          >
            {getInstallationStatus(installationStatus)}
          </Badge>
          {patchIsInstalled && patchApprovedOrRejcted && (
            <Tooltip
              title={getTranslatedText(
                intl,
                'asset.details.patch.install.by.user'
              )}
            >
              <span className="ml8 fx actr">
                <SVGIcon
                  name="HelpIcon"
                  size="sm"
                  color="var(--sops-black-to-black)"
                />
              </span>
            </Tooltip>
          )}
          {rebootRequired && workStation?.assetId && (
            <span className="ml8">
              <Button
                icon={<SVGIcon name="Reboot" />}
                onClick={toggleRebootConfirmation}
              >
                <FormattedMessage id="asset.details.action.reboot" />
              </Button>
              <Modal
                open={rebootConfirmation}
                onClose={() => toggleRebootConfirmation()}
                variant="confirmation"
                title={
                  <FormattedMessage id="asset.reboot.confirmation.heading" />
                }
                primaryAction={{
                  content: (
                    <div className="flex actr ">
                      <SVGIcon name="Reboot" />
                      <div className="ml8">
                        <FormattedMessage id="asset.details.reboot.modal.primaryText" />
                      </div>
                    </div>
                  ),
                  loading: rebootInProgress,
                  onAction: rebootAsset
                }}
                secondaryActions={[
                  {
                    content: <FormattedMessage id="common.cancel" />,
                    onAction: () => toggleRebootConfirmation()
                  }
                ]}
              >
                <div className="mt-10">
                  <FormattedMessage id="asset.reboot.confirmation.description" />
                </div>
              </Modal>
            </span>
          )}
          {rollBack && (
            <Tooltip title={getTranslatedText(intl, 'patch.rolled.back')}>
              <span className="ml8 fx actr">
                <SVGIcon
                  name="InlineError"
                  size="sm"
                  color="var(--sops-like-button-text)"
                />
              </span>
            </Tooltip>
          )}
        </div>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
    </>
  );
}

export default injectIntl(PatchStatusCell);
